import React from 'react';
import { IconsPros } from './types';

/**
 * Pending Icon component
 *
 * @returns JSX.ELEMENT
 */
export const PendingIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 13 14" data-testid={dataTestId}>
      <defs>
        <path id="a" d="M0 .064h2.59v2.59H0z" />
        <path id="c" d="M.075.085h1.554v1.554H.075z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M2.795 9.434c-.324 0-.599.113-.826.34-.227.226-.34.501-.34.825 0 .325.113.6.34.826.227.227.502.34.826.34.319 0 .592-.113.822-.34.23-.226.344-.501.344-.826 0-.324-.115-.599-.344-.825a1.129 1.129 0 0 0-.822-.34"
        />
        <g transform="translate(-.055 5.614)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#FFF"
            d="M2.59 1.359c0-.357-.126-.661-.38-.915a1.246 1.246 0 0 0-.915-.38C.94.064.635.19.38.444.127.698 0 1.002 0 1.359c0 .356.127.66.38.915.254.253.56.38.915.38.357 0 .662-.127.915-.38.254-.254.38-.559.38-.915"
          />
        </g>
        <path
          fill="#FFF"
          d="M2.795 1.92c-.394 0-.73.14-1.008.418a1.372 1.372 0 0 0-.417 1.007c0 .395.14.73.417 1.009.278.278.614.416 1.008.416s.73-.138 1.008-.416c.278-.278.417-.615.417-1.009 0-.394-.139-.73-.417-1.007a1.373 1.373 0 0 0-1.008-.417"
        />
        <g transform="translate(10.752 6.11)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#FFF"
            d="M1.402.312a.747.747 0 0 0-.55-.227c-.216 0-.4.075-.55.227a.75.75 0 0 0-.227.55c0 .216.075.4.226.55.151.152.335.227.551.227.216 0 .4-.075.55-.227a.747.747 0 0 0 .227-.55c0-.216-.075-.4-.227-.55"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#FFF"
          d="M10.049 9.693a.873.873 0 0 0-.64.267.873.873 0 0 0-.267.64c0 .248.089.46.267.639a.874.874 0 0 0 .64.267c.248 0 .461-.089.64-.267a.873.873 0 0 0 .267-.64.874.874 0 0 0-.268-.64.873.873 0 0 0-.639-.266M6.422 11.117a1 1 0 0 0-.733.304.999.999 0 0 0-.303.733c0 .286.1.53.303.732a.999.999 0 0 0 .733.304c.286 0 .53-.101.733-.304a.998.998 0 0 0 .304-.732 1 1 0 0 0-.304-.733 1 1 0 0 0-.733-.304M6.422.237c-.432 0-.799.15-1.101.453a1.5 1.5 0 0 0-.453 1.101c0 .432.15.799.453 1.101a1.5 1.5 0 0 0 1.101.453c.432 0 .799-.15 1.101-.453.302-.302.453-.669.453-1.1A1.5 1.5 0 0 0 7.523.69a1.5 1.5 0 0 0-1.1-.453"
        />
      </g>
    </svg>
  );
};
